<template>
  <div>
    <img
      class="photo-list-img clickable"
      :src="imageSrc"
      loading="lazy"
      v-visibility="onVisibilityChanged"
      :v-text="textAlternative"/>
  </div>
  </template>
  
  <script lang="ts">
  import { Vue, prop } from "vue-class-component";
  
import { ImageApi } from "@/api/image-api"
  
import { Watch } from "vue-property-decorator";

// Define props in a class
class PhotoThumbnailProps {
  photoId = prop({
    // Same as Vue core's prop option
    type: Number,
    required: true,
    default: {}
  })
  quality = prop({
    // Same as Vue core's prop option
    type: String,
    required: true,
    default: "240"
  })
  textAlternative = prop({
    // Same as Vue core's prop option
    type: String,
    required: false,
    default: ""
  })
}

export default class PhotoThumbnail extends Vue.with(PhotoThumbnailProps) {
    api = new ImageApi()
  
    is_loading = true;

    isVisible = false;
  
    imageSrc = ""

    @Watch('photoId')
    onPhotoIdChanged(val: number, oldVal: number) {
      if (val && this.photoId !== null) {
        this.getImageUrl(val, this.quality)
      }
    }

    @Watch('isVisible')
    onVisibilityVariableChanged(val: boolean, oldVal: boolean) {
      if (val && this.imageSrc === "" && this.photoId !== null) {
        this.getImageUrl(this.photoId, this.quality)
      }
    }
  
    mounted() {
      if (this.photoId !== null && this.isVisible && this.imageSrc === "") {
        this.getImageUrl(this.photoId, this.quality)
      }
    }

    onVisibilityChanged(isVisible: boolean) {
      this.isVisible = isVisible;
    }
  
    async getImageUrl(photoId: number, quality: string) {
      const response: any = await this.api.getSignedUrl(photoId, quality)
      if (response.data) {
        this.imageSrc = response.data
      }
    }
}
</script>
  
<style lang="stylus">
.photo-list-item:hover {
    border-color: #e2001a;
}

.photo-list-img { 
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}
  </style>
  